import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import { Email } from 'hb-react/shared/components/formik/components/inputs';

const PasswordResetForm = ({ onSubmit }) => (
  <>
    <Box font="h3-semibold">{__('Reset password')}</Box>
    <Box mt={4}>
      {__(
        'Please enter the email address connected to your account below. You will receive an email with a secure link to reset your password.',
      )}
    </Box>
    <Box mt={6}>
      <Formik initialValues={{ email: '' }} onSubmit={onSubmit}>
        {({ isValid, isSubmitting }) => (
          <StyledForm>
            <Email
              name="email"
              label={__('Email')}
              placeholder={__('Enter your email')}
              validate={{ required: true }}
            />
            <Box justifyContent="flex-end" mt={5}>
              <Button type="submit" isDisabled={isSubmitting || !isValid}>
                {__('Submit')}
              </Button>
            </Box>
          </StyledForm>
        )}
      </Formik>
    </Box>
  </>
);

PasswordResetForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default PasswordResetForm;

const StyledForm = styled(Form)`
  width: 100%;
`;
